import React from 'react';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import { _T } from 'appI18n';
export default function AsyncLoadError({ errorText }) {
    return React.createElement(Alert, { severity: "warning" },
        React.createElement(AlertTitle, null, _T.COMMON_OOPS),
        errorText);
}
